module.exports = __webpack_public_path__ + "img/icon-certificate.d7ff8e01.svg";